export default {
  en: {
    title: 'Tags',
    subtitle: 'List of tags.',
    columns: {
      name: 'Integration id',
      label: 'Label',
      description: 'Description',
    },
    form: {
      label: {
        error: 'Enter a valid tag name.',
        hint: 'The tag name will be visible by your agents.',
      },
      name: {
        error: 'Please enter a integration id.',
        hint: 'This is the id of integration will be send on webhooks.',
      },
      description: {
        hint: 'Description of tags will be visible for your agents.',
      },
    },
  },
  es: {
    title: 'Etiquetas',
    subtitle: 'Listado de etiquetas.',
    columns: {
      name: 'Id Integración',
      label: 'Etiqueta',
      description: 'Descripción',
    },
    form: {
      label: {
        error: 'Ingresa un nombre de etiqueta válido.',
        hint: 'Nombre de la etiqueta que será visible por tus agentes.',
      },
      name: {
        error: 'Por favor ingrese el id de integración.',
        hint: 'Este es un id de integración el cual será enviado en webhooks.',
      },
      description: {
        hint: 'Descripción de la etiqueta visible para tus agentes.',
      },
    },
  },
  fr: {
    title: 'Étiquettes',
    subtitle: 'Liste des étiquettes.',
    columns: {
      name: 'Id Intégration',
      label: 'Étiquette',
      description: 'Description',
    },
    form: {
      label: {
        error: 'Veuillez entrer un nom d\'étiquette valide.',
        hint: 'Nom de l\'étiquette visible par vos agents.',
      },
      name: {
        error: 'Veuillez entrer l\'id d\'intégration.',
        hint: 'Ceci est un id d\'intégration qui sera envoyé dans les webhooks.',
      },
      description: {
        hint: 'Description de l\'étiquette visible pour vos agents.',
      },
    },
  }

};
